import MatchCard from "@components/RefereeMatchCard";
import Navigator from "@components/RefereeMatchCard/Navigator";
import ScrollContainer from "@components/ScrollContainer";
import Spring from "@components/Spring";
import { useThemeProvider } from "@contexts/themeContext";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import ApiService from "../../network/ApiService";
import AuthService from "../../network/AuthService";
import styles from "./styles.module.scss";

const Matches = () => {
  const { direction } = useThemeProvider();
  const [selectedDay, setSelectedDay] = useState(dayjs().format("YYYY-MM-DD")); // full date format
  const [matches, setMatches] = useState([]);
  const apiService = new ApiService();
  const [team, setTeam] = useState(null);
  const [teamID, setTeamID] = useState(null);
  const [isCancelWindowOpen, setIsCancelWindowOpen] = useState(null);


  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const teamID = new AuthService().getTeamID();
        if (!teamID) return;
        setTeamID(teamID);

        const cancelResponse = await new ApiService().get(`transferSettings/isCancelPossible`);
        setIsCancelWindowOpen(cancelResponse);

        const response = await apiService.get(`teams/${teamID}/matches`);
        if (response) {
          setMatches(response);
          const team = await apiService.get(`teams/${teamID}`);
          setTeam(team);
        }
      } catch (error) {
        console.error("Failed to fetch matches:", error);
      }
    };

    fetchMatches();
  }, []);

  // Extract unique game days from matches
  const gamedays = [
    ...new Set(
      matches
        .map((m) => {
          const date = m.details?.date;
          return date ? dayjs(date).format("YYYY-MM-DD") : null;
        })
        .filter(Boolean)
    ),
  ].sort();

  // Filter matches for selected day
  const filteredMatches = matches
    .filter((match) => {
      const matchDate = match.details?.date;
      if (!matchDate) return false;
      const formatted = dayjs(matchDate).format("YYYY-MM-DD");
      return (
        formatted === selectedDay &&
        !["submitted", "done"].includes(match.status)
      );
    })
    .sort((a, b) => new Date(a.details.date) - new Date(b.details.date));

  return (
    <Spring className="card d-flex flex-column">
      <div
        className="card_header d-flex flex-column g-10"
        style={{ paddingBottom: 10 }}
      >
        <Navigator
          active={selectedDay}
          setActive={setSelectedDay}
          assignments={matches}
          gamedays={gamedays}
        />
      </div>

      <div className={styles.grid}>
        <div className={styles.scroll}>
          <ScrollContainer height={0}>
            <div
              className={`${styles.scroll_track} ${styles[direction]} track d-flex flex-column g-20`}
            >
              {filteredMatches.map((match, index) => (
                <MatchCard
                  match={match}
                  cancelCount={team?.cancelled}
                  postponeCount={team?.postponed}
                  isCancelWindowOpen={isCancelWindowOpen}
                  id={teamID}
                  index={index}
                  key={match.id || index}
                />
              ))}
            </div>
          </ScrollContainer>
        </div>
      </div>
    </Spring>
  );
};

export default Matches;
